module.exports = __webpack_public_path__ + "static/media/copyright.3d0f7c37.svg";